import React from 'react';

/**
 * CSS mockup of the six volumes, in the product palette.
 * Placeholder until the real box-set render (made from Volume 1 in Gamma)
 * is ready — then swap this component for an <img>.
 */
const volumes = [{
  n: '01',
  title: 'Foundations',
  weeks: 'Weeks 1–9',
  band: 'bg-sage'
}, {
  n: '02',
  title: 'Strength & Holds',
  weeks: 'Weeks 10–18',
  band: 'bg-plum'
}, {
  n: '03',
  title: 'Tempo & Endurance',
  weeks: 'Weeks 19–27',
  band: 'bg-coral'
}, {
  n: '04',
  title: 'Props & Variety',
  weeks: 'Weeks 28–36',
  band: 'bg-gold'
}, {
  n: '05',
  title: 'Balance & Center Floor',
  weeks: 'Weeks 37–44',
  band: 'bg-smoke'
}, {
  n: '06',
  title: 'Peak & Reset',
  weeks: 'Weeks 45–52',
  band: 'bg-blush-dark'
}];
export function VolumeStack({
  className = ''
}: {
  className?: string;
}) {
  return <div role="img" aria-label="52 Weeks of Barre: six volumes, from Foundations (weeks 1–9) to Peak & Reset (weeks 45–52)" className={`relative w-full select-none ${className}`} data-id="element-319" data-mp="1dqy5rjpnc9b9">
      <span aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center font-display italic font-semibold text-gold/15 leading-none text-[42vw] sm:text-[240px] lg:text-[260px]" data-id="element-320" data-mp="3li5mcjscyzxp">
        52
      </span>

      <div className="relative flex items-end justify-center px-2 pb-8 pt-10" data-id="element-321" data-mp="3v9t6dzml5ep5">
        {volumes.map((v, i) => {
        const offset = i - 2.5;
        return <div key={v.n} className="relative -ml-[8%] first:ml-0 w-[25%] aspect-[3/4] overflow-hidden rounded-[6px] bg-cream shadow-cover ring-1 ring-black/5" style={{
          transform: `rotate(${offset * 4.5}deg) translateY(${Math.abs(offset) * 7}px)`,
          zIndex: 10 - Math.round(Math.abs(offset))
        }} data-id="element-322" data-mp="32kcfx7ij07vk" data-mpi={i}>
              <div className="h-[40%] bg-plum px-[9%] pt-[11%]" data-id="element-323" data-mp="qspbg0ng4r2t">
                <span className="block text-[clamp(5px,1.3vw,9px)] font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-324" data-mp="vrsejfjv8n85">
                  Volume {v.n}
                </span>
                <span className="mt-[6%] block font-display italic text-[clamp(7px,1.7vw,12px)] leading-tight text-white/85" data-id="element-325" data-mp="2ntv4s8ti0hdk">
                  52 Weeks of Barre
                </span>
              </div>
              <div className="px-[9%] pt-[10%]" data-id="element-326" data-mp="2wujif2ezcfpx">
                <span className="block font-display font-semibold text-plum text-[clamp(8px,2.1vw,15px)] leading-[1.1]" data-id="element-327" data-mp="2wv2rruqkdvsc">
                  {v.title}
                </span>
                <span className="mt-[8%] block text-[clamp(5px,1.2vw,9px)] font-semibold uppercase tracking-[0.14em] text-ink-soft" data-id="element-328" data-mp="246nf3euwnpk6">
                  {v.weeks}
                </span>
              </div>
              {/* thin barre line, the recurring motif of the volumes */}
              <span className="absolute left-[9%] right-[9%] bottom-[18%] h-px bg-gold" data-id="element-329" data-mp="1qe7jv088wvtt" />
              <span className={`absolute inset-x-0 bottom-0 h-[8%] ${v.band}`} data-id="element-330" data-mp="1lfe574h82ys2" />
            </div>;
      })}
      </div>
    </div>;
}